module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/times-5197a6bbd03f604ddffb8a0514ab7624.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/times.svg
// module id = PLyF
// module chunks = 24